import { DataSet } from '../interfaces/DisplayInterfaces';
import { Chart } from 'angular-highcharts';
import * as _ from 'lodash';

export class TreeMapDataSetAdapter {

    static ChartConfig: Chart = <Chart>{};

    static CreateTreemapData(dataset: DataSet, groupColumns: string[], targetValueColumn: string): Highcharts.DataPoint[] {

        const pointCollection: Highcharts.DataPoint[] = [];
        const targetValueColumnIndex = dataset.columns.indexOf(targetValueColumn);
        TreeMapDataSetAdapter.RecurseGroup(dataset.columns, dataset.data, groupColumns, 0, targetValueColumn, pointCollection, '');

        return pointCollection;
    }

    static RecurseGroup(columns: string[],
        rows: string[][],
        groupColumns: string[],
        currentGIdx: number, targetValueColumn: string, pointCollection: Highcharts.DataPoint[], parentId: string): number {
        const gcIndex = columns.indexOf(groupColumns[currentGIdx]);
        const dictionary = _.groupBy(rows, x => { return x[gcIndex] });

        let total = 0;

        Object.keys(dictionary).forEach(k => {
            const rowSubset = dictionary[k];
            let groupTotal = 0;
            const newParentId = `${parentId}.${groupColumns[currentGIdx]}.${k}`;

            if (currentGIdx === groupColumns.length - 1) {
                // last group
                groupTotal = rows.reduce<number>((p, c) => { return p + Number(c[columns.indexOf(targetValueColumn)]); }, 0);
            } else {
                groupTotal =
                    this.RecurseGroup(columns, rowSubset, groupColumns, currentGIdx + 1, targetValueColumn, pointCollection, newParentId);
            }
            pointCollection.push({ id: newParentId, name: k, parent: parentId, value: groupTotal });
            total += groupTotal;
        });
        return total;
    }

    static GetbaseConfig(titleText = 'Treeemap in HighCharts module'): any {
        return new Chart({
            title: { text: titleText },
            credits: { enabled: false }
        });
    }

    static GetSeriesOptions(): any {
        const series: Highcharts.TreeMapChartSeriesOptions = {
            type: 'treemap',
            layoutAlgorithm: 'squarified',


            allowDrillToNode: true,
            dataLabels: { enabled: false },
            levelIsConstant: false,
            levels: [
                {
                    level: 3,
                    dataLabels: { enabled: true },
                    borderWidth: 3
                }
            ]
        }
        return series;
    }
}
